export default {
  waterwatchApiAuth: {
    username: "ZmEwYjNhNmYtN2JkYi00YzZjLWFmM2ItZWM4YTZlNzkzZTU2",
    password:
      "MTUzNDczNTE5NDoxODUwMDk1MTk0OjA0NmZjZDNiLTk1YzktNGJhNC1iNGNiLTQwYzVhNWFjYTg2Ng=="
  },

  useDevApi: false,

  orgId: "e84843d0-a427-11e8-9cfd-0b6989eb6485",
  orgName: "Waitati Community"
};